import React from "react";
import { Pane } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import NavComponent from "../../components/NavComponent";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { DepositRecordBackfill } from "../../components/admin/DepositRecordBackfill";
import { LibraryHarvest } from "../../components/admin/LibraryHarvest";
import { OverdueDetection } from "../../components/admin/OverdueDetection";
import { ScheduleRealignPanel } from "../../components/admin/ScheduleRealignPanel";
import { SkcHarvestSync } from "../../components/admin/SkcHarvestSync";
import styles from "./AdminDashboard.module.css";
export var AdminDashboard = function () {
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({
                id: "ui-br-legaldeposits.pane.title.navigation",
            }) },
            React.createElement("div", { className: styles.navContainer },
                React.createElement(NavComponent, null))),
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.admin.title" }) },
            React.createElement(SkcHarvestSync, null),
            React.createElement(LibraryHarvest, null),
            React.createElement(DepositRecordBackfill, null),
            React.createElement(OverdueDetection, null),
            React.createElement(ScheduleRealignPanel, null))));
};
